var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHyperlink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M9.36403 18.5003L8.43203 19.4323C7.58811 20.2762 6.44351 20.7503 5.25003 20.7503C4.05655 20.7503 2.91195 20.2762 2.06803 19.4323C1.22411 18.5884 0.75 17.4438 0.75 16.2503C0.75 15.0568 1.22411 13.9122 2.06803 13.0683L6.84103 8.29428C7.64125 7.49225 8.71455 7.02158 9.84661 6.97626C10.9787 6.93094 12.0862 7.31431 12.9479 8.04982C13.8097 8.78532 14.3623 9.81882 14.4954 10.9439C14.6286 12.0691 14.3324 13.203 13.666 14.1193",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.8162 5.56412L15.5662 4.81412C16.4102 3.9702 17.5548 3.49609 18.7482 3.49609C19.9417 3.49609 21.0863 3.9702 21.9302 4.81412C22.7742 5.65804 23.2483 6.80264 23.2483 7.99612C23.2483 9.1896 22.7742 10.3342 21.9302 11.1781L17.1572 15.9511C16.3569 16.7528 15.2835 17.2231 14.1516 17.2682C13.0197 17.3132 11.9124 16.9297 11.0508 16.1941C10.1892 15.4586 9.63681 14.4251 9.5038 13.3001C9.37078 12.1751 9.66698 11.0413 10.3332 10.1251",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperlink);
export default __webpack_public_path__ + "static/media/hyperlink.e6efccf841ef4822cdc21f94d04dc366.svg";
export { ForwardRef as ReactComponent };